import * as types from './types';
import { errHandler, getHost } from '@kk-activity-factory/utils';
const HOST = getHost();

export default {
    /**
     * 校验用户发帖权限
     * 有的用户在有些标签下不允许发弹幕/评论
     */
    async getPosterAuthorized({ commit }, obj) {
        return request({
            url: `${HOST}/v1/graph/users/authorities`,
            data: {
                target_type: 9,
                target_id: obj.postId,
            },
        })
            .then(({ data }) => {
                const hasForbiddenLabels =
                    obj.labels &&
                    obj.labels
                        .map((label) => {
                            return data.groupBlackList.includes(label.id);
                        })
                        .includes(true);

                commit(types.CAN_POST, {
                    hasAuthorized: true,
                    canPost: !(hasForbiddenLabels || data.blockBySuper),
                    blackList: data.groupBlackList,
                });
                return true;
            })
            .catch((err) => {
                errHandler(err);
                return false;
            });
    },
};
